import GoalsAdapter from './base';

export default class Badge extends GoalsAdapter {
  modelNamePlural = 'badges';
}
